module.exports = __webpack_public_path__ + "img/banner_wlx.c8ef08bf.jpg";